import nspell from "nspell";

export const PALABRAS_EXCEPCION = [
  "Netjer",
  "Netjernetworks",
  "Rexten",
  "BOM",
  "SOW",
  "Wi-Fi",
  "WiFi",
  "AP",
  "APs",
  "kick-off",
];

const REGEX_PALABRA = /[A-Za-zÀ-ÖØ-öø-ÿ]+(?:-[A-Za-zÀ-ÖØ-öø-ÿ]+)*/g;

const CLAVE_ALMACENAMIENTO = "docgen_diccionario_personalizado";

export const obtenerPalabrasPersonalizadas = () => {
  try {
    const guardado = window.localStorage.getItem(CLAVE_ALMACENAMIENTO);
    const lista = guardado ? JSON.parse(guardado) : [];
    return Array.isArray(lista) ? lista : [];
  } catch (error) {
    console.error("No se pudo leer el diccionario personalizado.", error);
    return [];
  }
};

const guardarPalabrasPersonalizadas = (palabras) => {
  try {
    window.localStorage.setItem(CLAVE_ALMACENAMIENTO, JSON.stringify(palabras));
  } catch (error) {
    console.error("No se pudo guardar el diccionario personalizado.", error);
  }
};

export const agregarPalabraAlDiccionario = (spell, palabra) => {
  const limpia = (palabra || "").trim();
  if (!limpia) return;
  spell.add(limpia);
  const actuales = obtenerPalabrasPersonalizadas();
  if (!actuales.includes(limpia)) {
    guardarPalabrasPersonalizadas([...actuales, limpia]);
  }
};

let corrPromesa = null;

export const cargarCorrector = () => {
  if (!corrPromesa) {
    const base = process.env.PUBLIC_URL || "";
    corrPromesa = Promise.all([
      fetch(`${base}/dictionaries/es.aff`).then((r) => r.text()),
      fetch(`${base}/dictionaries/es.dic`).then((r) => r.text()),
    ]).then(([aff, dic]) => {
      const spell = nspell({ aff, dic });
      PALABRAS_EXCEPCION.forEach((palabra) => spell.add(palabra));
      obtenerPalabrasPersonalizadas().forEach((palabra) => spell.add(palabra));
      return spell;
    });
  }
  return corrPromesa;
};

const aplicarCapitalizacion = (sugerencia, original) => {
  if (!sugerencia) return sugerencia;
  if (original === original.toUpperCase()) return sugerencia.toUpperCase();
  if (original[0] === original[0].toUpperCase()) {
    return sugerencia[0].toUpperCase() + sugerencia.slice(1);
  }
  return sugerencia;
};

export const revisarTexto = (spell, texto) => {
  if (!texto || typeof texto !== "string") return [];
  const encontradas = new Map();
  const coincidencias = texto.match(REGEX_PALABRA) || [];

  coincidencias.forEach((palabra) => {
    if (palabra.length < 2) return;
    if (encontradas.has(palabra)) return;
    if (spell.correct(palabra)) return;

    const sugerencias = spell
      .suggest(palabra)
      .slice(0, 5)
      .map((sugerencia) => aplicarCapitalizacion(sugerencia, palabra));

    encontradas.set(palabra, sugerencias);
  });

  return Array.from(encontradas, ([palabra, sugerencias]) => ({
    palabra,
    sugerencias,
  }));
};

export const aplicarCorreccionesTexto = (texto, correcciones) => {
  if (!texto || typeof texto !== "string") return texto;
  if (!correcciones || correcciones.size === 0) return texto;

  let resultado = texto;
  correcciones.forEach((reemplazo, palabraOriginal) => {
    if (reemplazo === palabraOriginal) return;
    const escapada = palabraOriginal.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    const regex = new RegExp(`\\b${escapada}\\b`, "g");
    resultado = resultado.replace(regex, reemplazo);
  });
  return resultado;
};